import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { Car } from 'app/models/car.model';
import { Container } from 'app/models/container.model';
import { Shift } from 'app/models/shift.model';
import { User } from 'app/models/user.model';
import { CarService } from 'app/services/car.service';
import { CompanyService } from 'app/services/company.service';
import { ContainerService } from 'app/services/container.service';
import { DateConvertService } from 'app/services/date-convert.service';
import { ShiftService } from 'app/services/shift.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from '../../base-form.component';


@Component({
    selector: 'app-shift',
    templateUrl: './shift.component.html',
    styleUrls: ['./shift.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class ShiftComponent extends BaseFormComponent implements OnInit {

    public companyId: number
    public shift: Shift = {
        status: true,
        containers: [],
    }
    public selectedCompany: number;
    public carList: Array<Car>
    public containerList: Array<Container>
    constructor(
        private _carService: CarService,
        private _containerService: ContainerService,
        private _toasterService: ToasterService,
        private _shiftService: ShiftService,
        private _companyService: CompanyService,
        private _converDate: DateConvertService,
        private _translateService:TranslateService
    ) {
        super();
    }

    async ngOnInit() {
        try {

            this.companyId =  parseInt(localStorage.getItem("CompanyID"))
        } catch (error) {
            console.warn(error);

        }
        if (this.operation == "update") {
            await this.carChange()
            let shiftContainer;
            try {
                shiftContainer = await this._shiftService.getContainerByShift(this.shift.id);

            } catch (error) {
                console.warn(error);

            }
            shiftContainer.forEach(x => {
                this.shift.containers.push(x.container);
                this.containerList = this.containerList.filter(a => a.id != x.container.id);
            })

        }
        await this.getCarList()
    }

    public async getCarList() {
        try {
            this.carList = await this._carService.getCars(this.companyId);
           // this.carList = this.carList.filter(x=>x.simulation!=true)
        } catch (error) {
            console.log(error);
        }
    }
    public async carChange() {
        try {
            this.containerList = await this._containerService.getContainers(this.companyId);
            this.containerList = this.containerList.filter(x => x.containerType != true)

        } catch (error) {
            console.warn(error);

        }
    }
    public containerChange(container) {

        const index = this.containerList.indexOf(container);
        this.containerList.splice(index, 1);
        this.shift.containers.push(container);
    }

    public containerUnChange(container) {
        const index = this.shift.containers.indexOf(container);
        this.shift.containers.splice(index, 1);
        this.containerList.push(container);
    }

    async submit(e) {
        this.shift.startDate = this._converDate.convertToLocalDate(this.shift.startDate);
        this.shift.endDate = this._converDate.convertToLocalDate(this.shift.endDate);
        this.shift.removeStatus = true;
        this.shift.status =true;
        if (e.invalid) {
            this._toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }

        if (this.operation == "create") {
            this.shift.companyId = this.carList.find(x => x.id == this.shift.carId).companyId;
            try {
                await this._shiftService.add(this.shift);
                this.added.emit(true);

            } catch (error) {
                console.warn(error);
                this.added.emit(false);

            }
        }
        else {
            try {
                await this._shiftService.updated(this.shift);
                this.updated.emit(true);

            } catch (error) {
                console.warn(error);
                this.updated.emit(false);

            }
        }

    }
}
